import { getStoryTimestamp, type BetaSearchSort } from './betaSearchSort';
import type { RankedStory } from './feedsV2';

/**
 * A feeds v2 list in the order the reader picked: the default keeps the
 * served rank order (rank score); recency puts the newest first; specificity
 * puts the most relevant first, by the story's best judged member relevance
 * (`rank_relevance`, what the rank score multiplies in). Ties keep rank order.
 */
export function sortV2Stories<T extends RankedStory>(stories: T[], sort: BetaSearchSort): T[] {
  if (!sort) return stories;
  const key = sort === 'recency' ? getStoryTimestamp : (story: T) => story.rank_relevance;
  return stories.map((story, index) => ({ story, index }))
    .sort((a, b) => key(b.story) - key(a.story) || a.index - b.index)
    .map(({ story }) => story);
}

/** The `sort` URL parameter as a sort; anything else is the default order. */
export function sortFromParam(value: string | null): BetaSearchSort {
  return value === 'recency' || value === 'specificity' ? value : null;
}

/** *params* with *sort* set, the default left out of the URL. */
export function withSortParam(params: URLSearchParams, sort: BetaSearchSort): URLSearchParams {
  const next = new URLSearchParams(params);
  if (sort) next.set('sort', sort); else next.delete('sort');
  return next;
}
